<template>
  <!--
      作者：kmdshop
      时间：2019-10-26
      描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <div class="common-form mt50">标签设置</div>
    <el-form-item>
      商品类型:
      <el-select v-model="form.model.attr_type" placeholder="请选择" @change="getDataByType">
        <el-option v-for="item in data" :key="item.attr_id" :label="item.attr_name" :value="item.attr_id"></el-option>
      </el-select>

      <el-form-item v-for="(item,index) in list" :key="index">
        <el-col :span="6" style="display: flex;margin-top: 20px">
          <div style="width: 61px" class="el-form-item"> {{ item.attr_value_name }}</div>

          <el-input v-model="item.attr_input" autocomplete="off" v-if="item.attr_type ==1"></el-input>

          <el-radio-group v-model="item.attr_radio" v-if="item.attr_type == 2" v-for="(v,k) in item.attr_value_arr" :key="k" style="margin-top: 10px;">
            <el-radio :label="v" v-if="v" style="padding: 5px;">{{ v }}</el-radio>

          </el-radio-group>

          <el-checkbox-group v-for="(val,ke) in item.attr_value_arr" v-if="item.attr_type == 3" :key="ke" v-model="item.attr_box">
            <el-checkbox :label="val" v-if="val" style="padding: 5px;">{{ val }}</el-checkbox>

          </el-checkbox-group>
        </el-col>

      </el-form-item>

    </el-form-item>

    <!-- 关联标签 -->
    <Label :form="form" :type="type"></Label>

    <!-- 关联商品 -->
    <RelationProduct :form="form" :type="type"></RelationProduct>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Label from './Label'
import RelationProduct from './Relationproduct';

export default {
  components: {
    // 关联标签
    Label,
    // 关联商品
    RelationProduct,
  },
  data() {
    return {
      data: [],
      loading: true,
      list: [],
    };
  },
  inject: ['form'],
  props: {
    type: String
  },
  watch:
    {
      list: {
        handler(n, o) {
          console.log(n.length)
          if(n.length >0){
            this.list = n
          }else{
            console.log("??")
            this.list = [{
              attr_id:-1,
              attr_type:-1,
            }]
            this.form.model.list  =  this.list
            console.log(this.list)
          }
         
        },
        deep: true
      }
    }, created() {
    this.getAttrData();
    this.list = [...this.form.model.list]
  },
  methods: {
    getAttrData: function () {
      let self = this;
      PorductApi.getAttrData({}, true)
        .then(res => {
          self.loading = false;
          var arr = [{
            attr_name:"不选择商品类型",
            attr_id:-1
          }]
          self.data = arr.concat(res.data.list) 
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getDataByType() {
      let check = this.form.model.attr_type
      // console.log(check)
      let self = this;
      PorductApi.getAttrDataById({attr_id: check}, true)
        .then(res => {
          self.loading = false;
          self.form.model.list = res.data.attr
          self.list = res.data.attr
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/product/part/attr.vue